module.exports = __webpack_public_path__ + "img/eivind-berre-p.8dd0976e.jpg";